<template lang="pug">
.multiple-wrapper
  ValidationObserver(ref="form")
    .generic-wrapper
      .container
        .two-column
          .column
            h2.title.is-6 E-Mail Anhang
            iframe(ref="pdf-preview").pdf-preview
          .column
            .form.w640
              h2.title.is-6 E-Mail schreiben
              ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                b-field(label="E-Mail Betreff" label-position="on-border"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                  b-input(v-model="formData.subject")
              ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                b-field(label="E-Mail Text" label-position="on-border"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                  vue-editor(v-model="formData.body" :editorOptions="editorOptions")
</template>

<script>
export default {
  props: {
    offers: {
      type: Array
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        reloadPDF: false,
        isPDFLoading: false,
      formData: {
        subject: `${this.offers.length > 1 ? 'Unsere Angebote' : 'Unser Angebot'} zu Ihrer Anfrage`,
        body: null,
        optionalOfferText: null
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        focus: false,
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  mounted() {
    this.mountData();
  },
  watch: {
    offers: {
      deep: true,
      handler() {
        this.mountData('isUpdate');
      }
    }
  },
  methods: {
    async mountData(isUpdate) {
      const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
      let offerTemplate = emailTemplates.find(e => e.uuid === 'OFFER_EMAIL');
      if (isUpdate) {
        offerTemplate = {
            ...offerTemplate,
            subject: this.formData.subject,
            body: this.formData.body
        }
      }
      const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: offerTemplate, booking: this.offers[0]});
      this.$set(this.formData, 'subject', result.template.subject);
      this.$set(this.formData, 'body', result.template.body);

      if (this.offers[0] && this.offers[0].customer) {
        if (this.isPDFLoading) {
          this.reloadPDF = true;
        } else {
          this.generatePDF();
        }
      }
    },
    async generatePDF() {      
      const pdfArraybuffer = await this.$store.dispatch("rentObjectBookings/offerMultiplePDFPreview", {offers: this.offers});
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"].src = URL.createObjectURL(pdfBlob);
      
        this.isPDFLoading = false;
        if (this.reloadPDF) {
            this.reloadPDF = false;
            this.generatePDF();
        }
    },
    sendOffer(sendEmail, callback) {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        const copyOffers = JSON.parse(JSON.stringify(this.offers));
        const bookings = [];
        for (let i = 0; i < copyOffers.length; i += 1) {
          const newBooking = await this.$store.dispatch("rentObjectBookings/create", {...copyOffers[i], ...copyOffers[i].bookingItems, verifyTotal: copyOffers[i].bookingItems.total, bookingItems: []});
          copyOffers[i].rentObjectBookingId = newBooking.id;
          bookings.push(newBooking);
        }
        await this.$store.dispatch("offers/createMultiple", {...this.formData, offers: copyOffers, sendEmail});
        loadingComponent.close();
        callback();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.multiple-wrapper {
  background-color: white;
}

.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>